// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__3eQMC","icon":"style_icon__1RCJc"};